
interface CTASectionProps {
  onContactClick: () => void;
}

export default function CTASection({ onContactClick }: CTASectionProps) {
  return (
    <section className="py-12 sm:py-16 lg:py-24 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4 sm:mb-6">
            Transformeer Uw Regievoering
          </h2>
          <p className="text-lg sm:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            EasyTravel is Plug & Play. Modules voor routebeheer en reizigersprofielen zijn standaard, maar maatwerk koppelingen zijn altijd mogelijk.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 sm:gap-12 items-center mb-12 sm:mb-16">
          <div>
            <h3 className="text-2xl sm:text-3xl font-bold text-white mb-6">
              Waarom EasyTravel de Juiste Keuze is
            </h3>
            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-teal-500 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-plug-line text-white text-lg sm:text-xl"></i>
                </div>
                <div>
                  <h4 className="text-lg sm:text-xl font-bold text-white mb-2">Plug & Play Implementatie</h4>
                  <p className="text-gray-300 text-sm sm:text-base">Standaard modules voor routebeheer en reizigersprofielen zijn direct inzetbaar. Snelle implementatie zonder lange doorlooptijden.</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-blue-500 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-settings-3-line text-white text-lg sm:text-xl"></i>
                </div>
                <div>
                  <h4 className="text-lg sm:text-xl font-bold text-white mb-2">Maatwerk Koppelingen</h4>
                  <p className="text-gray-300 text-sm sm:text-base">Flexibele integratiemogelijkheden met uw bestaande systemen. Onze experts zorgen voor naadloze koppelingen op maat.</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-green-500 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-customer-service-2-line text-white text-lg sm:text-xl"></i>
                </div>
                <div>
                  <h4 className="text-lg sm:text-xl font-bold text-white mb-2">Persoonlijke Begeleiding</h4>
                  <p className="text-gray-300 text-sm sm:text-base">Neem contact op voor een gesprek over uw specifieke vervoersvraagstukken. Onze specialisten denken graag met u mee.</p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 sm:p-8 border border-white/20">
            <h3 className="text-xl sm:text-2xl font-bold text-white mb-6 text-center">
              Start Vandaag Nog
            </h3>
            <div className="space-y-4">
              <div className="bg-white/5 rounded-lg p-4 border border-white/10">
                <div className="flex items-center space-x-3">
                  <div className="w-6 h-6 sm:w-8 sm:h-8 bg-teal-500 rounded-full flex items-center justify-center text-white font-bold text-xs sm:text-sm">1</div>
                  <span className="text-white text-sm sm:text-base">Gratis account aanmaken</span>
                </div>
              </div>
              <div className="bg-white/5 rounded-lg p-4 border border-white/10">
                <div className="flex items-center space-x-3">
                  <div className="w-6 h-6 sm:w-8 sm:h-8 bg-teal-500 rounded-full flex items-center justify-center text-white font-bold text-xs sm:text-sm">2</div>
                  <span className="text-white text-sm sm:text-base">Tot 5 ritten gratis testen</span>
                </div>
              </div>
              <div className="bg-white/5 rounded-lg p-4 border border-white/10">
                <div className="flex items-center space-x-3">
                  <div className="w-6 h-6 sm:w-8 sm:h-8 bg-teal-500 rounded-full flex items-center justify-center text-white font-bold text-xs sm:text-sm">3</div>
                  <span className="text-white text-sm sm:text-base">Upgrade naar volledig account</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center">
          <button
            onClick={onContactClick}
            className="bg-teal-500 text-white px-8 sm:px-12 py-3 sm:py-4 rounded-lg font-bold text-lg sm:text-xl hover:bg-teal-600 transition-colors cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl transform hover:scale-105"
          >
            Neem Contact Op
          </button>
          <p className="text-gray-400 mt-4 text-sm sm:text-base">
            Klaar om uw vervoersprocessen te optimaliseren? Laten we praten over uw specifieke behoeften.
          </p>
        </div>
      </div>
    </section>
  );
}
